import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
}) => {
  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Meta */}
      <meta
        name="description"
        content={description}
      />

      <meta
        name="keywords"
        content={keywords}
      />

      {/* Canonical */}
      <link
        rel="canonical"
        href={url}
      />

      {/* Open Graph */}
      <meta property="og:type" content="website" />

      <meta
        property="og:title"
        content={title}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:image"
        content={image}
      />

      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={title}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content={image}
      />

      {/* Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "TekIT Software Solutions Pvt Ltd",
          url: "https://www.tekitsolution.com",
          logo: "https://www.tekitsolution.com/logo.png",
          sameAs: [
            "https://www.linkedin.com/company/tekit-softwares",
          ],
        })}
      </script>
    </Helmet>
  );
};

export default SEO;